<widget data-testid="aggregated-vcc-widget" title="Total VCCs Charged" [subTitle]="'Shows the aggregated charged card data.'+ (dateFilterText | async)">
  <div data-testid="aggregated-vcc-chart-wrap" class="widget-chart-wrap" widgetContent>
    <div *ngIf="isLoading" id="aggregated-vcc-loading" class="loading-container">
      <mat-spinner diameter="30"></mat-spinner>
      <span>Loading chart data...</span>
    </div>

    <div *ngIf="isError && !isLoading" id="aggregated-vcc-error" class="error-container">
      <mat-icon>info</mat-icon>
      <span>No data for the chosen parameters.</span>
    </div>

    <chart *ngIf="!isLoading && !isError && dataAggregated && dataAggregated.labels && dataAggregated.labels.length > 0" data-testid="aggregated-vcc-chart"
      [dataSet]="dataAggregated"
      [chartType]="'bar'"
      [useZoom]="true"
      (chartClick)="navigateToReport($event)"
      [options]="aggregatedVccChartOptions">
    </chart>

    <div *ngIf="!isLoading && !isError && (!dataAggregated || !dataAggregated.labels || dataAggregated.labels.length === 0)" id="aggregated-vcc-empty" class="empty-container">
      <mat-icon>info</mat-icon>
      <span>No data for the chosen parameters.</span>
    </div>
  </div>
</widget>